import React, { createContext, useContext, useState } from 'react'

const FooterContext = createContext();

export const useFooterContext = () => {
  const context = useContext(FooterContext);
  if (!context) {
    throw new Error('useFooterContext must be used within a FooterProvider');
  }
  return context;
};

export const FooterProvider = ({ children }) => {
  const [projectContainerWidth, setProjectContainerWidth] = useState(0)

  const setProjectContainerWidthFn = (width) => {
    setProjectContainerWidth(width)
  }

  const getProjectContainerWidthFn = () => {
    return projectContainerWidth
  }

  const value = {
    setProjectContainerWidthFn: setProjectContainerWidthFn,
    getProjectContainerWidthFn: getProjectContainerWidthFn,
  };

  return (
    <FooterContext.Provider value={value}>
      {children}
    </FooterContext.Provider>
  );
};
